import { Route, Routes } from 'react-router-dom'
import { Layout } from '@/components/layout/Layout'
import { RouteChangeEffects } from '@/components/RouteChangeEffects'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { ROUTES } from '@/lib/site'

import Home from '@/pages/Home'
import Method from '@/pages/Method'
import SectionsPage from '@/pages/Sections'
import Projection from '@/pages/Projection'
import Provenance from '@/pages/Provenance'
import Security from '@/pages/Security'
import Company from '@/pages/Company'
import Faq from '@/pages/Faq'
import Contact from '@/pages/Contact'
import NotFound from '@/pages/NotFound'

export function App() {
  return (
    <ErrorBoundary>
      <RouteChangeEffects />
      <Routes>
        <Route element={<Layout />}>
          <Route path={ROUTES.home.path} element={<Home />} />
          <Route path={ROUTES.method.path} element={<Method />} />
          <Route path={ROUTES.sections.path} element={<SectionsPage />} />
          <Route path={ROUTES.projection.path} element={<Projection />} />
          <Route path={ROUTES.provenance.path} element={<Provenance />} />
          <Route path={ROUTES.security.path} element={<Security />} />
          <Route path={ROUTES.company.path} element={<Company />} />
          <Route path={ROUTES.faq.path} element={<Faq />} />
          <Route path={ROUTES.contact.path} element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  )
}
